module.exports = __webpack_public_path__ + "img/winerackdog28.84a2b68f.jpg";